/**
 * Simple footer with branding.
 */
export function LandingFooter() {
  return (
    <footer className="py-12 px-6 border-t border-gray-100">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <img src="/vrmeet_logo.png" alt="VR Meet" className="h-6 w-6" />
          <span className="text-sm text-gray-400">VR Meet</span>
        </div>
        <p className="text-sm text-gray-400">
          Bringing teams together in virtual reality.
        </p>
      </div>
    </footer>
  );
}
